import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

export enum FiToggleSwitchLabelAlign {
    Left = 'Left',
    Right = 'Right',
}

export enum FiToggleSwitchSliderColorClass {
    Green = 'toggle-switch-slider-color-green',
    Branded = 'toggle-switch-slider-color-branded',
}

@Component({
    selector: 'fi-toggle-switch',
    template: `
        @if (isLabelShown(FiToggleSwitchLabelAlign.Left)) {
            <span class="switch-label">{{ label }}</span>
        }
        <label class="switch-wrapper" [ngClass]="{ disabled: disabled }">
            <input
                type="checkbox"
                class="switch-input"
                [disabled]="disabled"
                [(ngModel)]="value"
                (ngModelChange)="onToggle($event)"
            />
            <span class="switch-slider" #rippleTrigger [class]="switchSliderColorClass">
                <span class="inner-circle">
                    <span class="inner-circle-ripple-wrapper">
                        <span matRipple [matRippleTrigger]="rippleTrigger" [matRippleColor]=""></span>
                    </span>
                    @if (isCheckIconDisplayed) {
                        <mat-icon class="fas fa-check" />
                    }
                </span>
            </span>
        </label>
        @if (isLabelShown(FiToggleSwitchLabelAlign.Right)) {
            <span class="switch-label">{{ label }}</span>
        }
    `,
    styleUrls: ['./fi-toggle-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-toggle-switch' },
    standalone: false,
})
export class FiToggleSwitchComponent {
    @Input() value: boolean;
    @Input() label: string;
    @Input() labelAlign: FiToggleSwitchLabelAlign;
    @Input() switchSliderColorClass: FiToggleSwitchSliderColorClass = FiToggleSwitchSliderColorClass.Green;
    @Output() valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() isCheckIconDisplayed: boolean;

    @HostBinding('class.disabled') @Input() disabled: boolean;
    @HostBinding('class.small-switch-size') @Input() isSmallSwitchSize: boolean;
    @HostBinding('class.keep-color-when-disabled') @Input() keepColorWhenDisabled: boolean;

    protected readonly FiToggleSwitchLabelAlign = FiToggleSwitchLabelAlign;

    protected onToggle($event: boolean) {
        this.valueChange.emit($event);
    }

    protected isLabelShown(labelAlign: string): boolean {
        return this.labelAlign === labelAlign;
    }
}
